export default {
    mainTitle: 'Reset password',
    confirmationTitle: "We've sent you an email explaining how to reset your password.",
    confirmationMessage: "If you don't see an email after a few minutes, try checking your spam folder.",
    confirmationButton: 'Back to login screen',
    securityMessage: '100% Secure & Authorised',
};
